var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.48 2.9H15.3945L15.3812 2.9845L14.6265 7.796H11.8049L12.5548 3.0155L12.5729 2.9H12.456H10.368H10.2821L10.2691 2.9849L9.53811 7.772H6.84H6.74V7.872V9.984V10.084H6.84H9.14635L8.603 13.412H6H5.9V13.512V15.624V15.724H6H8.1874L7.41317 20.7448L7.3954 20.86H7.512H9.6H9.68497L9.69869 20.7761L10.525 15.724H13.3229L12.5252 20.7443L12.5069 20.86H12.624H14.736H14.821L14.8347 20.7761L15.661 15.724H18.408H18.508V15.624V13.512V13.412H18.408H15.9816L16.525 10.084H19.224H19.324V9.984V7.872V7.772H19.224H16.8936L17.6667 3.01605L17.6856 2.9H17.568H15.48ZM14.2111 10.084L13.6904 13.412H10.8937L11.437 10.084H14.2111Z",
    fill: "#202020",
    stroke: "#202020",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.516d5d227293a49ba3f2053016ccf013.svg";
export { ForwardRef as ReactComponent };